import { render, staticRenderFns } from "./InternalInfo.vue?vue&type=template&id=bb8d4174"
import script from "./InternalInfo.vue?vue&type=script&lang=js"
export * from "./InternalInfo.vue?vue&type=script&lang=js"
import style0 from "./InternalInfo.vue?vue&type=style&index=0&id=bb8d4174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports